export default __webpack_public_path__ + "static/media/ORANGINA.afce3283.gif";